module.exports = __webpack_public_path__ + "img/electricity-full.648ea5f1.svg";